// extracted by mini-css-extract-plugin
module.exports = {"cont":"ShutDown_cont__2n61F","desc":"ShutDown_desc__3PG6o"};